(function () {
    'use strict';

    Directives.CompanyMembershipDirective = function CompanyMembershipDirective() {

        // @ngInject
        function CompanyMembershipDirectiveControllerCtor(
            $scope, $injector, $log, _, UsersManager, CompaniesManager,
            StripeHelperService, PopupMessageService, AnalyticsService, OnboardingService, UiPersistenceService, moment,
            ModalService, $translate, $, AppStates, $state, $stateParams, $window, Enums, PricingPlansService, AccountsManager, FeaturesService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'CompanyMembershipDirectiveController';

            this._ = _;
            this.$translate = $translate;
            this.$log = $log;
            this.UsersManager = UsersManager;
            this.StripeHelperService = StripeHelperService;
            this.PopupMessageService = PopupMessageService;
            this.AnalyticsService = AnalyticsService;
            this.CompaniesManager = CompaniesManager;
            this.ModalService = ModalService;
            this.OnboardingService = OnboardingService;
            this.UiPersistenceService = UiPersistenceService;
            this.AppStates = AppStates;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.Enums = Enums;
            this.moment = moment;
            this.PricingPlansService = PricingPlansService;
            this.UiPersistenceService = UiPersistenceService;
            this.AccountsManager = AccountsManager;
            this.$window = $window;
            this.FeaturesService = FeaturesService;

            this.showCancelMembership = false;
            this.cancellationHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.membershipCancellationViewed) || {};
            this.faqs = [];

            this.updateFaqTexts = function updateFaqTexts(monthly, annualSavings) {
                this.faqs = [
                    {
                        title: 'MEMBERSHIP_FAQ._DIFFERENCES_TITLE_',
                        content: 'MEMBERSHIP_FAQ._DIFFERENCES_CONTENT_',
                        analyticsProperty: "DIFFERENCES_BETWEEN_PLANS",
                        contentTranslateProperties: {
                            price_monthly_amount: monthly,
                            annual_savings_amount: annualSavings
                        }
                    },
                    {
                        title: 'MEMBERSHIP_FAQ._MAXIMUM_TITLE_',
                        content: 'MEMBERSHIP_FAQ._MAXIMUM_CONTENT_',
                        analyticsProperty: "MAXIMUM_PROJECTS"
                    },
                    {
                        title: 'MEMBERSHIP_FAQ._PAYMENT_METHOD_TITLE_',
                        content: 'MEMBERSHIP_FAQ._PAYMENT_METHOD_CONTENT_',
                        analyticsProperty: "PAYMENT_METHOD"
                    },
                    {
                        title: 'MEMBERSHIP_FAQ._FEES_TITLE_',
                        content: 'MEMBERSHIP_FAQ._FEES_CONTENT_',
                        analyticsProperty: "FEES"
                    },
                    {
                        title: 'MEMBERSHIP_FAQ._EASY_TITLE_',
                        content: 'MEMBERSHIP_FAQ._EASY_CONTENT_',
                        analyticsProperty: "EASY_TO_GET_STARTED"
                    },
                    {
                        title: 'MEMBERSHIP_FAQ._MONEY_BACK_TITLE_',
                        content: 'MEMBERSHIP_FAQ._MONEY_BACK_CONTENT_',
                        analyticsProperty: "MONEY_BACK"
                    }
                ];
            };

            this.updateFaqTexts(40, 40 * 2);

            this.pricingPlans = [];
            // the current one if exists
            this.activePricingPlan = null;

            this.selectedPaymentOption = null;

            this.user = this.UsersManager.getCurrUser();

            this.company = this.user.company;
            this.loading = true;
            this.discount_hb = false; //this is the old indication that the prices are after a discount (it could be coming from the server utm..)
            this.isPromocodePricingPlans = false; //this is the new one

            this.pricingPlanMonthly = null;
            this.pricingPlanOnetime = null;

            this.lastError = null;
            this.showLastError = false;
            this.updatingPaymentMethod = false;

            this.targetedOfferCountDownEnds = null;

            this.promoCodeFlows = {
                FROM_PARAMS: {value: 'from_params', priority: 1},
                TEMP_WALL: {value: 'temp_wall', priority: 2},
                NONE: {value: 'none', priority: 4},
            };
            this.curPromoCodeStateIndex = 0;
            this.initPricingPlanData();

            this.testimonials = {
                'photographer': {
                    vid: '-zBXz8bMsbo',
                    excerpt: 'You\'re going to be able to get faster, better bookings and your clients are going to love you for it because it was easy for them.',
                    firstName: 'Mark',
                    lastName: 'Dickinson',
                    industryType: 'Photographer',
                    industryTypePlural: 'photographers'
                },
                'other': {
                    vid: 'NC6lyAU-RzU',
                    excerpt: 'It has literally changed the way that we do business. We noticed instantly that our client retention went straight up.',
                    firstName: 'Candice',
                    lastName: 'Coppola',
                    industryType: 'Planner / Designer',
                    industryTypePlural: 'creatives'
                }
            };

            if (this.user.company.company_type === 'photographer') {
                this.testimonial = this.testimonials.photographer;
            } else {
                this.testimonial = this.testimonials.other;
            }

            this.paymentProcessingPercent = 3;
            this.seenMembership();
            this.resetSubmitButton();

            this.useRecurlyBillingForm = !!this.user.getSubscription();
        }

        var CompanyMembershipDirectiveController = Class(Controllers.BaseController, {
            constructor: CompanyMembershipDirectiveControllerCtor,

            shouldShowRecurlySubscription: function shouldShowRecurlySubscription() {
                return !this.loading &&
                    !this.hasActivePlan() &&
                    !this.showCancelMembership &&
                    this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.subscriptionManagement)
            },

            shouldShowStripeSubscription: function shouldShowStripeSubscription() {
                return !this.loading &&
                    !this.hasActivePlan() &&
                    !this.showCancelMembership &&
                    !this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.subscriptionManagement)
            },

            hideCancelMembership: function hideCancelMembership() {
                this.showCancelMembership = false;
            },

            onCancelClick: function onCancelClick() {
                if(this.activePricingPlan.in_app_purchase_product) {
                    this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, 'SETTINGS.SUBSCRIPTION._CANCEL_IN_APP_PURCHASE_', 'FREQUENT_BUTTONS._CONTINUE_', 'FREQUENT_BUTTONS._CANCEL_')
                        .then(function confirmCancelInApp() {
                            this.$window.open('https://apps.apple.com/account/subscriptions', '_blank');
                        }.bind(this));
                } else {
                    this.showCancelMembership = true;
                }
            },

            seenMembership: function () {
                if (this.hasActivePlan) {
                    this._shouldShouldCancellation();
                }
            },

            _shouldShouldCancellation: function _shouldShouldCancellation() {
                if (!this.cancellationHash.seen) {
                    this.showCancellationButton = false;
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.membershipCancellationViewed, {seen: true});
                } else {
                    this.showCancellationButton = true;
                }
            },

            onCancelMembership: function onCancelMembership() {
                this.hideCancelMembership();
                this.PopupMessageService.showAlertPromise(this.PopupMessageService.severityTypes.info, 'SETTINGS.SUBSCRIPTION._MISS_YOU_', 'FREQUENT_BUTTONS._OK_');
                this.loading = true;
                this.AccountsManager.getPricingPlanForAccount(this.company.account_id).then(function success(resp) {
                    this._setPricingPlan(resp.data.pricing_plan);
                    return this.fetchAvailablePricingPlans();
                }.bind(this)).finally(function final() {
                    this.loading = false;
                }.bind(this));
            },

            onPauseMembership: function onPauseMembership() {
                // optimistic flag update for updating the flag instead of refetching the user
                this.user.company.account.subscription_paused_date = true;

                this.hideCancelMembership();
                this.loading = true;
                this.AccountsManager.getPricingPlanForAccount(this.company.account_id).then(function success(resp) {
                    this._setPricingPlan(resp.data.pricing_plan);
                    return this.fetchAvailablePricingPlans();
                }.bind(this)).finally(function final() {
                    this.loading = false;
                }.bind(this));
            },

            hasActivePlan: function hasActivePlan() {
                return this.activePricingPlan && !this.activePricingPlan.canceled;
            },

            hasCanceledPlan: function hasCanceledPlan() {
                return this.activePricingPlan && this.activePricingPlan.canceled;
            },

            hasPausedPlan: function hasPausedPlan() {
                return this.user && this.user.company && this.user.company.account && this.user.company.account.subscription_paused_date;
            },

            hasExpiredPausedPlan: function hasExpiredPausedPlan() {
                return this.hasPausedPlan() && !this.activePricingPlan;
            },

            isPayWallParent: function isPayWallParent() {
                //checking if parent controller is pay wall modal
                return this.$parent.payWallVm && this.$parent.payWallVm._objectType === "PayWallController";
            },

            updatePricingTexts: function updatePricingTexts(percent) {
                this.paymentProcessingPercent = percent;
            },

            handleGotPricingPlans: function handleGotPricingPlans(plans) {
                // update pricing for venues and/or other non-standard processing fee plans
                var monthlyPlan = this._.find(plans, {plan_type: 'monthly'});

                if (monthlyPlan.credit_card_fee !== 3) {
                    this.updatePricingTexts(monthlyPlan.credit_card_fee);
                }

                if ((monthlyPlan.amount !== 40 && !monthlyPlan.original_amount) || monthlyPlan.original_amount) {
                    var faqPriceMonthly = monthlyPlan.original_amount ? monthlyPlan.original_amount : monthlyPlan.amount;
                    this.updateFaqTexts(faqPriceMonthly, faqPriceMonthly * 2);
                }


                //check if these plans are a discounted version (the discount could have been done on the server without user
                //intervention by comming to hb via external url with utm params
                this.isPromocodePricingPlans = this._.any(plans, function (pricingPlan) {
                    return pricingPlan.is_discounted;
                });
                this.pricingPlans = plans;
                // this is a hack to 'refresh' the modified toggle view
                if (this.selectedPricingPlan) {
                    // get the old type
                    var selectedType = this.selectedPricingPlan.plan_type;
                    // set selected to the right new type
                    this.selectedPricingPlan = this._.find(plans, {plan_type: selectedType});
                    this.selectedPricingPlan.isSelected = true;
                }
            },

            updateBillingInfo: function updateBillingInfo(token) {
                if(this.updatingPaymentMethod) {
                    return;
                }

                this.updatingPaymentMethod = true;
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.update_billing_info);

                this.AccountsManager.updateBillingInfo(token.id).then(function handleChangedCardSuccess(res) {
                    this.showEditPaymentInfo = false;
                    this._setPricingPlan(res.data.pricing_plan);

                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.update_billing_info);
                }.bind(this))
                    .catch(function error(res) {
                        var analyticsData = {};
                        var errorMessage =  'ERRORS.SERVER_API._UNKNOWN_';
                        if (res && res.error && res.error.message) {
                            errorMessage = res.error.message;
                        } else if (res && res.data && res.data.error_message) {
                            errorMessage = res.data.error_message;
                        }

                        this.cardError = errorMessage;

                        analyticsData.error = res ? res : "no error data";
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.update_billing_info, analyticsData);
                    }.bind(this))
                    .finally(function finallyHandler() {
                        this.updatingPaymentMethod = false;
                    }.bind(this));
            },

            resetSubmitButton: function resetSubmitButton() {
                this.isSubmitTriggered = false;
            },

            onSubmit: function onSubmit() {
                this.isSubmitTriggered = true;
            },

            onPricingPlanPaid: function onPricingPlanPaid(plan) {
                var promptAccountSetup = !this.activePricingPlan;
                this._setPricingPlan(plan);
                this.useRecurlyBillingForm = !!this.user.getSubscription();

                // force get the company all over so that the trial properties will update
                this.CompaniesManager.getCurrCompany(true);
                this.toggleEditCreditCard(false);

                if (this.isModal) {
                    this.dismissModal();
                }

                this.company.once('success', function onCompanyUpdated(){
                    if(promptAccountSetup && !this.isPayWallParent()){
                        this.showAccountSetupPopup();
                    }
                    this.CompaniesManager.triggerCompanySubscribed();
                }.bind(this));
            },

            updateCreditCardDetails: function updateCreditCardDetails(stripeToken) {
                this.updatingPaymentMethod = true;
                var analyticsEvent = 'update card details';
                this.AnalyticsService.trackClick(this, analyticsEvent);

                var cardToAdd = stripeToken.card;
                cardToAdd.token_id = stripeToken.id;
                this.AccountsManager.changePaymentMethod(this.company.account_id, cardToAdd)
                    .then(function handleChangedCardSuccess(res) {
                        this.showEditPaymentInfo = false;
                        this._setPricingPlan(res.data.pricing_plan);

                        this.AnalyticsService.trackSuccess(this, analyticsEvent);
                    }.bind(this))
                    .catch(function error(res) {
                        var analyticsData = {};
                        var errorMessage =  'ERRORS.SERVER_API._UNKNOWN_'; //a default error message
                        if (res && res.error && res.error.message) {
                            errorMessage = res.error.message;
                        } else if (res && res.data && res.data.error_message) {
                            errorMessage = res.data.error_message;
                        }

                        this.cardError = errorMessage;

                        analyticsData.error = res ? res : "no error data";
                        this.AnalyticsService.trackError(this, analyticsEvent, analyticsData);
                    }.bind(this))
                    .finally(function finallyHandler() {
                        this.updatingPaymentMethod = false;
                    }.bind(this));
            },

            showAccountSetupPopup: function showAccountSetupPopup(){
                if(this.company.offer_account_setup){
                    this.AnalyticsService.trackLoad(this, 'account setup offer popup');
                    this.PopupMessageService.showConfirm(
                        this.PopupMessageService.severityTypes.info,
                        'COMPANY_SETTING.SETUP._TIME_TO_SETUP_ACCOUNT_',
                        this.gotToAccountSetup.bind(this),
                        this.accountSetupPopupDissmissed.bind(this),
                        'COMPANY_SETTING.SETUP._SETUP_ACCOUNT_',
                        'COMPANY_SETTING.SETUP._LATER_');
                }
            },

            gotToAccountSetup: function gotToAccountSetup(){
                this.AnalyticsService.trackClick(this, "account setup offer accepted", {source: "membership page"});
                this.goToState(this.AppStates.root_core_accountSetup);
            },

            accountSetupPopupDissmissed: function accountSetupPopupDissmissed() {
                this.AnalyticsService.trackClick(this, "account setup offer declined", {source: "popup"});
            },

            initPricingPlanData: function initPricingPlanData() {
                this.promoCode = this.$stateParams['promo'] || this.$stateParams['discountCode'];
                var tempPaywallPromoCode = this.OnboardingService.getTempPaywallDiscount();

                if (this.promoCode && this.curPromoCodeStateIndex < this.promoCodeFlows.FROM_PARAMS.priority) {
                    // cancel onboarding - it had unlreated problems at the time of implementing discount code landing, and most of users complete it anyway.
                    if (this.OnboardingService.isOnboardingActive()) {
                        this.OnboardingService.abortOnboarding('discount code ' + this.promoCode + ' applied');
                    }
                    this.curPromoCodeStateIndex = this.promoCodeFlows.FROM_PARAMS.priority;
                    this.submitDiscountCode();

                } else if (tempPaywallPromoCode && this.curPromoCodeStateIndex < this.promoCodeFlows.TEMP_WALL.priority) {
                    this.promoCode = tempPaywallPromoCode;
                    this.curPromoCodeStateIndex = this.promoCodeFlows.TEMP_WALL.priority;
                    this.submitDiscountCode();

                } else {
                    this.curPromoCodeStateIndex = this.promoCodeFlows.NONE.priority;
                    var subscription = this.user.getSubscription();
                    if(subscription && !subscription.isExpired()) {
                        this._setPricingPlan(subscription.pricing_plan);
                        this.loading = false;
                    } else {
                        this.AccountsManager.getPricingPlanForAccount(this.company.account_id)
                            .then(function gotPricingPlan(res) {
                                this._setPricingPlan(res.data.pricing_plan);

                                if(!res.data.pricing_plan || !this.hasActivePlan()) {
                                    // because we are returning the promise all error will be handled in the catch.
                                    return this.fetchAvailablePricingPlans();
                                }
                            }.bind(this))
                            .catch(function fail(res) {
                                if (res && res.data && res.data.error_message) {
                                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, res.data.error_message);
                                } else {
                                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNKNOWN_');
                                }
                            }.bind(this))
                            .finally(function() {
                                this.loading = false;
                            }.bind(this));
                    }
                }
            },

            submitDiscountCode: function submitDiscountCode() {
                this.lastError = null;

                if (this._.isEmpty(this.promoCode)) {
                    //do nothing if the promo code box is empty
                    this.showLastError = false;
                    return;
                }

                this.PricingPlansService.getAvailablePricingPlans(this.company, this.promoCode).then(function gotAvailablePricingPlans(plans) {
                    this.isPromocodePricingPlans = true;
                    this.showDiscountInputField = false;
                    this.handleGotPricingPlans(plans);
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.promo_codes_submitted, {promo_code: this.promoCode});
                    this.loading = false;
                }.bind(this))
                .catch(function fail(res) {
                    this.promoCode = null;
                    this.isPromocodePricingPlans = false;
                    if (res && res.data && res.data.error_message) {
                        this.lastError = res.data.error_message;
                    } else {
                        this.lastError = 'ERRORS.SERVER_API._UNKNOWN_';
                    }

                    this.showLastError = true;

                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.promo_codes_submitted, res, {promo_code: this.promoCode});

                    if (!this.selectedPricingPlan) {
                        this.initPricingPlanData();
                    } else {
                        this.loading = false;
                    }
                }.bind(this));
            },

            onPromocodeTextChanged: function onPromocodeTextChanged() {
                this.showLastError = false;
            },

            toggleEditCreditCard: function toggleEditCreditCard(enable) {
                if(enable && this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.blockSubscriptionActions)) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, '<b>Maintenance in progress</b></br></br>' +
                        'Over the next few days, we’re working on making it easier for you to edit your subscription. ' +
                        'Please contact <a href="mailto:concierge@honeybook.com">concierge@honeybook.com</a> to make changes to your billing information.');
                    return;
                }

                this.cardError = '';
                this.showEditPaymentInfo = enable;
                this.resetSubmitButton();
            },

            _setPricingPlan: function setPricingPlan(plan) {
                if (plan) {
                    this.cardError = '';
                    this.activePricingPlan = plan;
                    this.shouldPayNextPayment = this.moment().isAfter(plan.next_charge_date);

                    //add the additional view model properties that are neede for display
                    this.PricingPlansService.addAdditionalDataForPlanViewModel(plan);

                } else {
                    this.activePricingPlan = null;
                }
            },

            nTillTrialEnds: function nTillTrialEnds() {
                return this.user && this.user.nTillTrialEnds();
            },

            handleClickVideoTestimonial: function handleClickVideoTestimonial() {

                var videoOptions = {
                    modalOpenSource: 'Membership testimonial',
                    videoTitle: '',
                    videoLink: 'https://www.youtube.com/embed/' + this.testimonial.vid + '?autoplay=1&rel=0'
                };

                this.ModalService.openGenericVideoModal(videoOptions);

            },

            videoTestimonialBackgroundPoster: function videoTestimonialBackgroundPoster() {
                return {'background-image': 'url(//i.ytimg.com/vi/' + this.testimonial.vid + '/hqdefault.jpg)'};
            },

            showMembershipDetails: function showMembershipDetails() {
                return Boolean(
                    !this.loading &&
                    this.hasActivePlan() &&
                    !this.showCancelMembership &&
                    !this.isModal);
            },

            getPricingPlanAmount: function getPricingPlanAmount() {
                var subscription = this.user.getSubscription();
                if (!subscription && this.activePricingPlan.plan_type === this.Enums.pricingPlanTypes.annual) {
                    return this.activePricingPlan.last_payment_amount || this.activePricingPlan.amount;
                }

                return this.activePricingPlan.amount;
            },

            trackClickTestimonials: function trackClickTestimonials() {
                this.AnalyticsService.trackClick(this, 'customers link', {user_company_type: this.user.company.company_type});
            },

            getPricingPlanPaymentMethod: function getPricingPlanPaymentMethod() {
                var _paymentMethod;

                switch (this.activePricingPlan.in_app_purchase_device) {
                    case "ios":
                        _paymentMethod = 'App Store';
                        break;
                    case "android":
                        _paymentMethod = 'Play Store';
                        break;
                    default:
                        if (!this.activePricingPlan.payment_method) {
                            _paymentMethod = "Not Valid";
                        } else {
                            _paymentMethod = '**** **** **** ' + this.activePricingPlan.payment_method.last4;
                        }

                }

                return _paymentMethod;
            },

            fetchAvailablePricingPlans: function fetchAvailablePricingPlans() {
                return this.PricingPlansService.getAvailablePricingPlans(this.company).then(function gotAvailablePricingPlans(plans) {
                    this.handleGotPricingPlans(plans);
                }.bind(this));
            },

            getPricingPlanName: function getPricingPlanName() {
                return (this.activePricingPlan.plan_name || this.activePricingPlan.plan_type);
            }
        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/settings/company/subscription/company_membership/company_membership_template.html',
            controller: CompanyMembershipDirectiveController,
            controllerAs: 'companyMembershipVm',
            bindToController: true,
            scope: {
                isModal: '=',
                dismissModal: '&',
            },
        };
    };

}());

